import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _get from 'lodash/get';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import ScrollBodyComponent from './scrollBodyComponent';
import withVirtualizedTable from './withVirtualizedTable';
function withInfiniteScroll(WrappedComponent) {
  var WithInfiniteScroll = /*#__PURE__*/function (_Component) {
    _inherits(WithInfiniteScroll, _Component);
    var _super = _createSuper(WithInfiniteScroll);
    function WithInfiniteScroll() {
      var _this;
      _classCallCheck(this, WithInfiniteScroll);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "getInfiniteScrollProps", defaultMemoize(function (useInfiniteScroll) {
        if (!useInfiniteScroll) {
          return EMPTY_OBJECT;
        }
        return {
          TableComponent: _this.renderBodyComponent,
          getTableProps: _this.getTableProps
        };
      }));
      _defineProperty(_assertThisInitialized(_this), "renderBodyComponent", function (props) {
        return /*#__PURE__*/React.createElement(ScrollBodyComponent, props);
      });
      _defineProperty(_assertThisInitialized(_this), "getTableProps", function (state) {
        return {
          loading: state.loading,
          scrollLoading: state.scrollLoading,
          totalNumberOfEntries: state.totalNumberOfEntries,
          minRows: state.minRows,
          onAction: state.onAction,
          itemType: state.itemType,
          scrollState: state.scrollState,
          fetchOnScrollThreshold: _get(state, 'fetchOnScrollThreshold', 5)
        };
      });
      return _this;
    }
    _createClass(WithInfiniteScroll, [{
      key: "render",
      value: function render() {
        var useInfiniteScroll = this.props.useInfiniteScroll;
        var infiniteScrollProps = this.getInfiniteScrollProps(useInfiniteScroll);
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, infiniteScrollProps));
      }
    }]);
    return WithInfiniteScroll;
  }(Component);
  WithInfiniteScroll.propTypes = {
    useInfiniteScroll: PropTypes.bool.isRequired
  };
  return withVirtualizedTable(WithInfiniteScroll);
}
export default withInfiniteScroll;